import React from "react";
import PageErrorBoundary from "./ErrorHandler";

const SafePage = ({ pageName = "Website Page", children }) => {
  return (
    <PageErrorBoundary pageName={pageName} silent={false}>
      {children}
    </PageErrorBoundary>
  );
};

export default SafePage;
